import React from 'react'
import { Link } from 'react-router-dom'
import { home, googleReview, instagram } from '../images/index'

const BottomBar = () => {
	return (
		<div
			className='bottomBar  px-6 py-4 flex justify-between items-center rounded-full w-3/4 fixed bottom-5   left-1/2 -translate-x-1/2'
			style={{
				background:
					'radial-gradient(162.71% 1672.88% at 91.03% 128.81%, rgba(235, 0, 255, 0.3) 0%, rgba(235, 0, 255, 0.045) 100%) , radial-gradient(551.69% 3369.39% at -62.31% -308.47%, rgba(19, 31, 108, 0.8) 100%, rgba(19, 31, 108, 1) 100%)',
			}}
		>
			<Link to={'/'} className=''>
				<img className='w-7 h-7' src={home} alt='Home icon'></img>
			</Link>
			<a className='' href='https://maps.app.goo.gl/1t4m7i7DU8avNNke8' target={'_blank'}>
				<img className='w-7 h-7' src={googleReview} alt='google review icon'></img>
			</a>
			<a href='www.instagram.com' target={'_blank'}>
				<img className='w-7 h-7' src={instagram} alt='instagram icon'></img>
			</a>
		</div>
	)
}

export default BottomBar
